import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, of, skipWhile, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import MessagingAccount from '../../model/messagingAccount.model';
import {catchError, switchMap} from 'rxjs/operators';
import MessagingVerification from '../../model/messagingVerification.model';
import MessagingPagination from "../../model/messagingPagination.model";
import MessagingMessage from "../../model/messagingMessage.model";
import Crypto from "../../helper/crypto";
import {cache} from "../../cache";

@Injectable()
export default class MessagingAccountService {
    constructor(private http: HttpClient) {
    }

    list(query?: string, page?: number, limit?: number, orderBy?: string, additional?: any, useCache?: boolean): Observable<MessagingPagination<MessagingAccount>> {
        useCache = useCache || false;
        query = query || '';
        page = page || 1;
        limit = limit || 30;
        // if (limit > 100) { limit = 100; }
        if (limit <= 0) { limit = 15; }
        const q = [];
        if (query) {
            q.push('query=' + query);
        }
        if (page) {
            q.push('page=' + page);
        }
        if (orderBy) {
            q.push('order=' + orderBy);
        }
        q.push('itemsPerPage=' + limit);
        /*let q = {
            query, 'page': 'page=' + page, limit
        };*/
        if(additional) {
            for(let key of Object.keys(additional)) {
                q.push(key + '=' + additional[key]);
            }
        }
        const url = environment.apiUrl + '/messaging/accounts' + '?' + q.join('&');

        const key = 'cache-' + Crypto.SHA1(url);
        const subject = new BehaviorSubject<MessagingPagination<MessagingAccount>>(null);

        if(page == 1) {
            cache.getCacheItem(key).then(result => {
                if(result) {
                    subject.next(JSON.parse(result.result));
                }
            });
        }

        this.http.get<MessagingPagination<MessagingAccount>>(url).subscribe(result => {
            subject.next(result);
            cache.removeCacheItem(key).then(_ => {
                cache.insertCacheItem({
                    id: key,
                    result: JSON.stringify(result)
                });
            });
        });

        return subject.pipe(skipWhile(e => {
            return e == null
        }));
    }

    create(messagingAccount: MessagingAccount): Observable<MessagingAccount> {
        return this.http.post<MessagingAccount>(environment.apiUrl + '/messaging/accounts', messagingAccount);
    }

    public show(accountId: string, useCache?: boolean): Observable<MessagingAccount> {
        useCache = useCache || false;
        const url = environment.apiUrl + '/messaging/accounts/' + accountId;

        return this.http.get<MessagingAccount>(url).pipe(switchMap(result => {
            return of(result);
        }));
    }

    public verify(account: MessagingAccount): Observable<MessagingVerification> {
        return this.http.post<MessagingVerification>(environment.apiUrl + '/messaging/accounts/verify', account);
    }

    public flush(account: MessagingAccount): Observable<MessagingVerification> {
        return this.http.post<MessagingVerification>(environment.apiUrl + '/messaging/accounts/' + account.id + '/flush', account);
    }

    public update(messagingAccount: MessagingAccount): Observable<MessagingAccount> {
        return this.http.put<MessagingAccount>(environment.apiUrl + '/messaging/accounts/' + messagingAccount.id, messagingAccount);
    }

    public delete(messagingAccount: MessagingAccount): Observable<boolean> {
        return this.http.delete<boolean>(environment.apiUrl + '/messaging/accounts/' + messagingAccount.id).pipe(
            switchMap(r => of(true)),
            catchError(e => of(false))
        );
    }
}
